import Image from 'next/image';
import cover from '../../../public/assets/images/zynoff_hero_image.svg';
import CookieSettingsLink from '@/components/consent/CookieSettingsLink';

interface Props {
  children: React.ReactNode;
}

export const AuthLayoutWrapper = ({ children }: Props) => {
  return (
    <div className="flex w-full min-h-screen items-center justify-center bg-light-primary-100 py-5">
      <div className="flex w-[80%] 2xl:max-w-[1418px] shadow-lg rounded-lg overflow-hidden">
        {/* Left Side: Form */}
        <div className="flex-[2] xl:flex-[5] 2xl:flex-[1] flex flex-col items-center py-5 lg:py-8 justify-center bg-white min-h-fit">
          <div className="px-5 lg:px-20 w-full">{children}</div>
          <CookieSettingsLink className="mt-4" />
        </div>

        {/* Right Side: Image Background */}
        <div className="hidden xl:flex xl:flex-[5] 2xl:flex-[1] relative bg-[#001E00] min-h-[600px]">
          <div className="absolute inset-[9%]">
            <Image
              className="object-contain"
              src={cover}
              alt="background image"
              fill
              priority
              sizes="50vw"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
